import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { DisposableSafelly } from '../disposable-safelly/disposable-safelly.component';
import { SettingsService } from '../../services/settings/settings.service';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UsersState } from '../../state-management/users/users.reducer';
import { LoginWraperService } from '../../services/login.wraper.service';
import { TrackingActions } from '../../state-management/tracking/tracking.action';
import { LiveStreamAction } from '../../state-management/live-stream/live-stream.action';
import { AppState } from '../../interfaces/app-state.interface';
import { LiveSetting } from '../../resources/live-setting';

@Component({
    selector: 'live-section-advisory',
    templateUrl: './live-section-advisory.component.html',
    styleUrls: ['./live-section-advisory.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveSectionAdvisoryComponent extends DisposableSafelly implements OnInit {

    public liveId: string;
    public liveStatus: number;
    public isActive: boolean = false;
    public auth$: Observable<UsersState>;
    public isLogged: boolean = null;
    public registerAppUrl = this.settingsService.getConfigurationKeyValue('rau');
    public channelId: string = '';

    @Input('backTheme') public backTheme: string = LiveSetting.backgroundStyle.lighter;
    @Input('activeLiveChat') public activeLiveChat: boolean = true;

    @Input('opened')
    public set opened(opened) {
        this.isActive = !!opened;
    }

    @Input() public channel: string = 'assessoria';
    @Input() public idLivePi: string = '';
    @Input() public title: string = '';
    @Input() public subtitle: string = '';
    @Input() public origin: string = '';
    @Input() public isRounded: boolean = false;

    @Output() public toogleValue = new EventEmitter<boolean>();

    public get isActiveLiveChat() {
        return this.activeLiveChat;
    }

    public get isDarkTheme() {
        return this.backTheme === LiveSetting.backgroundStyle.dark;
    }

    public get backgroundTheme() {
        return this.backTheme;
    }

    public get watchLabel() {
        return this.isActive ? 'Fechar' : 'Assistir agora';
    }

    public get liveChatUri(): string {
        const urlHostName = window.location.hostname;
        return `https://www.youtube.com/live_chat?v=${this.liveId}&embed_domain=${urlHostName}`;
    }

    public get channelUri(): string {
        return `https://www.youtube.com/v/${this.liveId}`;
    }

    constructor(
        private store: Store<AppState>,
        private settingsService: SettingsService,
        private changeDetectorRef: ChangeDetectorRef,
        private loginWraper: LoginWraperService,
    ) {
        super();
        this.auth$ = this.store.select((s) => s.authentication);

        this.disposableSubscriptions.push(
            this.auth$
                .subscribe((data) => {
                    this.isLogged = !!data.currentUser;
                }),
        );

        if (!this.isMobile()) {
            this.isActive = true;
        }
    }

    public ngOnInit(): void {
        this.getLiveData();

        this.disposableSubscriptions.push(
            this.store
                .select((liveStore) => liveStore.liveStream.live)
                .pipe(
                    filter((live) => !!live),
                )
                .subscribe((live) => {
                    this.liveId = live.videoid;
                    this.liveStatus = live.status;
                    this.changeDetectorRef.markForCheck();
                    this.channelId = live.channelOutId;
                }),
        );
    }

    public setChannelId() {
        if (this.channel === 'stock') {
            this.channelId = LiveSetting.liveChannel.stock.channelId;
        } else {
            this.channelId = LiveSetting.liveChannel.advisory.channelId;
        }
    }

    public reloadChat() {
        this.getLiveData();
    }

    public gotToChannel() {
        this.sendToTracking('Foi para YouTube');
        this.isActive = !this.isActive;
    }

    public getLiveData() {
        this.store.dispatch({type: LiveStreamAction.getLive, payload: this.channel});
    }

    public togglePanel() {
        this.sendToTracking(!this.isActive ? 'Abrir Live' : 'Fechar Live');
        this.isActive = !this.isActive;
    }

    public login() {
        this.loginWraper.navigateToLogin({afterLoginRedirectTo: '/investir'});
    }

    public goToRegister() {
        this.sendToTracking('Chat Register Button');
        window.location.href = this.registerAppUrl;
    }

    public isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    private sendToTracking(element: string) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: `User Clicked`,
                events: {
                    origin: this.origin !== '' ? this.origin : 'Home Bolsa',
                    element
                },
            },
        });
    }
}
